import { useTranslation } from "react-i18next"
import InfoCard from "./InfoCard"

export default function BasicInfoSection({ basicInfo }) {
  const { t } = useTranslation()
  return (
    <div className="space-y-4">
      <div className="bg-[#1F3A60] text-white p-4 rounded-lg">
        <h2 className="text-lg md:text-xl font-semibold">{t("fstp_page.basicInfo.basicTitle")} | {basicInfo.title}</h2>
      </div>
{/* 
      <div className="text-left w-full">
        <InfoCard label="Fecal Sludge Treatment Technology" value={basicInfo.technology} />
      </div> */}

      <div className="grid grid-cols-1 lg:grid-cols-2 gap-4 text-left">
        <InfoCard label={t("fstp_page.basicInfo.adminDivision")} value={basicInfo.administrativeDivision} />
        <InfoCard label={t("fstp_page.basicInfo.areaName")} value={basicInfo.areaName} />
      </div>

      <div className="grid grid-cols-1 lg:grid-cols-2 gap-4 text-left">
        <InfoCard
          label={t("fstp_page.basicInfo.owner")}
          value={basicInfo.assetOwner}
          logo={"/BD-logo.png"}
          logoAlt="Government logo"
          
        />
        <InfoCard
          label={t("fstp_page.basicInfo.organization")}
          value={basicInfo.organization}
          logo={basicInfo.organizationLogo}
          logoAlt="Organization logo"
        />
      </div>
      <div className="text-center w-full">
        <InfoCard label={t("fstp_page.basicInfo.projectName")} value={basicInfo.projectName}  variant="AlignJustify"/>
      </div>
    </div>
  )
}
